import { Component, computed, Signal } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { PanelModule } from 'primeng/panel';
import { PopoverModule } from 'primeng/popover';
import { TooltipModule } from 'primeng/tooltip';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-user-info',
  imports: [AvatarModule, TooltipModule, PopoverModule, PanelModule, BadgeModule, OverlayBadgeModule ],
  templateUrl: './user-info.component.html',
})
export class UserInfoComponent {
  initials:Signal<string>;
  displayName: Signal<string>;
  name:Signal<string>;
  id:Signal<string>;
  jobTitle:Signal<string>;
  userPrincipalName: Signal<string>;
  photo:Signal<string | undefined>;
  notify = false;
  notification = '';

  constructor(private user: UserService) {
    this.displayName = this.user.displayName;
    this.name = this.user.name
    this.initials = computed(() => this.getInitialsFromName(this.name()));
    this.id = computed(() => this.user.id() && `[${this.user.id()}]`);
    this.jobTitle = this.user.jobTitle;
    this.userPrincipalName = this.user.userPrincipalName;
    this.photo = this.user.photo;
  }

  getInitialsFromName(name: string) {
    return name.split(',')
      .map(part => part.trim().charAt(0))
      .reverse()
      .join('');
  }

}
